import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { SecurePost } from "../../../services/axiosCall";
import apis from "../../../services/Apis";
import Alert from "../../common/alert";
// import { changeStep } from "../../../actions/testAction";
import { changeActiveStep } from "../../../reducers/test";

const FinalQuestionView = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const test = useSelector((state) => state.test);
  const [creating, setCreating] = useState(false);
  console.log("test",test);
  

  const createTest = () => {
    setCreating(true);
    SecurePost({
      url: apis.CREATE_TEST,
      data: {
        type: test.newtestFormData.testType,
        title: test.newtestFormData.testTitle,
        questions: test.newtestFormData.testQuestions,
        duration: test.newtestFormData.testDuration,
        subjects: test.newtestFormData.testSubject,
        organisation: test.newtestFormData.OrganisationName,
        level: test.newtestFormData.level,
        exam: test.newtestFormData.exam,
        school: test.newtestFormData.school,
        term: test.newtestFormData.term,
        year: test.newtestFormData.year,
      },
    })
      .then((response) => {
        if (response.data.success) {
          Alert(
            "success",
            "Test paper Created Successfully!",
            "Please wait, you will automatically be redirected to conduct test page."
          );
          setTimeout(() => {
            navigate(`/user/conducttest?testid=${response.data.testid}`);
          }, 3000);
        } else {
          Alert("error", "Error!", response.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
        const message = error.response
          ? error.response.data.message
          : error.message;
        Alert("error", "Error!", message);
      })
      .finally(() => setCreating(false));
  };

  return (
    <div>
      {test?.newtestFormData?.testQuestions.map((d, i) => (
        <QuestionView key={i + 1} _id={d} no={i + 1} />
      ))}
      <div style={{ width: "100%", padding: "10px" }}>
        <Button
          style={{ float: "right" }}
          type="primary"
          onClick={createTest}
          loading={creating}
        >
          Create Test
        </Button>
        <Button
          style={{ float: "right", marginRight: "1%" }}
          type="primary"
          onClick={() => dispatch(changeActiveStep(1))}
        >
          Previous
        </Button>
      </div>
    </div>
  );
};

export default FinalQuestionView;

const QuestionView = ({ _id, no }) => {
  const test = useSelector((state) => state.test);
  const question = test.questionsAvailablebasedonSubject.find(
    (q) => q._id === _id
  );

  if (!question) return null;

  const oo = ["A", "B", "C", "D", "E"];
  const image = question?.quesimg?.split("www.leagueonline.sg:5000");
  const path = apis.BASE_LOCAL_URL;

  const extension = question?.quesimg
    ? image[0] === "https://"
      ? image[1]?.split(".").pop().toLowerCase()
      : question.quesimg.split(".").pop().toLowerCase()
    : "";

  const isImage = ["jpg", "jpeg", "png", "gif", "bmp"].includes(extension);
  const isVideo = ["mp4", "avi", "mov", "mkv"].includes(extension);

  return (
    <div style={{ marginBottom: "20px" }}>
      <Row>
        <Col span={20}>
          <b style={{ float: "left" }}>Q. {no}) &nbsp;</b>
          <div dangerouslySetInnerHTML={{ __html: question.body }} />
          {question.quesimg && (
            <div className="questionDetailsImageContainer">
              {isImage ? (
                <img
                  src={
                    image[0] === "https://"
                      ? path + image[1]
                      : `${path}/${question.quesimg}`
                  }
                  className="image-tag"
                  alt=""
                />
              ) : isVideo ? (
                <video className="image-tag" controls>
                  <source
                    src={
                      image[0] === "https://"
                        ? path + image[1]
                        : `${path}/${question.quesimg}`
                    }
                    type="video/mp4"
                  />
                </video>
              ) : null}
            </div>
          )}
          <br />
          {question.isMcq ? (
            <div style={{ width: "100%" }}>
              {question.options.map((d, i) => (
                <Col key={i} span={12} style={{ padding: "10px 20px" }}>
                  <b style={{ marginLeft: 8 }}>{oo[i]}) </b> {d.optbody}
                  {d.optimg && (
                    <img
                      crossOrigin="anonymous"
                      alt="Option"
                      width="150px"
                      height="150px"
                      className="questionDetailsImage"
                      src={d.optimg}
                      style={{ marginLeft: "12px" }}
                    />
                  )}
                </Col>
              ))}
            </div>
          ) : (
            <Col style={{ padding: "10px 20px" }}></Col>
          )}
        </Col>
        <Col span={4}>
          <b style={{ float: "right" }}>Marks: {question.weightage}</b>
        </Col>
      </Row>
    </div>
  );
};

